import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, watch } from "vue";
import MainCardFront from "@/components/main/MainCardFront.vue";
import MainCardBack from "@/components/main/MainCardBack.vue";
import { IFavoriteLine } from "@/domain/entities/favoriteLine";
import { computed } from "@vue/reactivity";
import { LineTypeCode } from "@/types";
import MainCardShuttle from "@/components/main/MainCardShuttle.vue";
import { IBusStop } from "@/domain/entities/busStop";
import { IOnBoardLine } from "@/domain/entities/onBoardLine";


const __default__ = {
  name: "MainCard",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  favoriteLine: {
    type: Object as PropType<IFavoriteLine>,
    required: true,
  },
  shouldCurrentCardShowFront: {
    type: Boolean,
    default: true,
  },
  cardIndex: {
    type: Number,
    required: true,
  },
  currentCardIndex: {
    type: Number,
    required: true,
  },
  onBoardLine: {
    type: Object as PropType<IOnBoardLine>,
  },
},
  emits: ["updateBusLocation", "onClickLineInfo", "onClickScheduleBtn", "onClickBusStopLocation", "onChangedCheck", "onClickReportBtn", "onClickBusImage"],
  setup(__props, { expose: __expose }) {

const props = __props;



const mainCardFront = ref<typeof MainCardFront>();
const mainCardBack = ref<typeof MainCardBack>();
const mainCardShuttle = ref<typeof MainCardShuttle>();

const updateKey = ref(0);
const isInsideShuttle = computed(
  () => props.favoriteLine.lineTypeCode === LineTypeCode.Inside
);
const startAnimation = ref(false);
const startFlipAnimation = () => {
  if (props.cardIndex !== props.currentCardIndex) return;

  startAnimation.value = true;
  setTimeout(() => {
    startAnimation.value = false;
  }, 600);
};
const shouldShowFront = ref(true);
const updateShouldShowFrontValue = () => {
  shouldShowFront.value =
    props.shouldCurrentCardShowFront ||
    props.cardIndex !== props.currentCardIndex;
};

const shouldRenderCard = (isFront: boolean) => {
  if (isFront) {
    return shouldShowFront.value || startAnimation.value;
  }
  return (
    (!shouldShowFront.value && props.cardIndex === props.currentCardIndex) ||
    startAnimation.value
  );
};

const closeTooltip = () => {
  mainCardFront.value?.closeTooltip();
  mainCardBack.value?.closeBusPlateNumbersTooltip();
  mainCardShuttle.value?.closeBusPlateNumbersTooltip();
};

__expose({ closeTooltip });

watch(
  () => [props.shouldCurrentCardShowFront, props.currentCardIndex],
  ([, oldIndex], [, newIndex]) => {
    updateShouldShowFrontValue();
    if (oldIndex === newIndex) {
      startFlipAnimation();
    }
  }
);

const __returned__ = { props, mainCardFront, mainCardBack, mainCardShuttle, updateKey, isInsideShuttle, startAnimation, startFlipAnimation, shouldShowFront, updateShouldShowFrontValue, shouldRenderCard, closeTooltip, MainCardFront, MainCardBack, MainCardShuttle }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})